export const checkHasNotVerifiedRequirements = (
  flujoAprobaciones: $TSMigrationFixMe
) =>
  flujoAprobaciones.some(
    (element: $TSMigrationFixMe) => !element.todosLosRangos
  )

export const CURRENT_PAYMENT_TYPE = {
  COBRO: 1,
  PAGO: 2,
}

export const emptyBankAccount = {
  id: "",
  entidadBancariaNombre: "",
  iban: "Sin cuenta bancaria",
}

export const dontEditPagoCobroRelacion = 2
